export enum HallsAPIRoutes {
    GET_HALLS = "hall:query",
    GET_HALL = "hall:get",

    GET_SUBSIDIARIES = "subsidiary:query",
    GET_CONFIGURATIONS_LIST = "config:settings:versions",
    //GET_LATEST_STATUS_TIMESTAMP = "status:hallset-latest",
    CREATE_HALL = "hall:create",
    UPDATE_HALL = "hall:update",
    DELETE_HALL = "hall:delete",
    GET_SERVERS = "server:query",
    GET_SERVER = "server:get",
    CREATE_SERVER = "server:create",
    EDIT_SERVER = "server:update",
    CLONE_SERVER = "server:clone",

    //GET_CASH_SYSTEMS = "config:lists:subsidiary:cashing",
    GET_CORE_VERSIONS = "config:lists:versions:system_server",

    ACTIVATE_HALL = "hall:activate",

    ACTIVATE_SERVER = "server:activate",

    TOGGLE_SERVER_DEBUG_MODE = "server:set_debug_mode",

    TOGGLE_SERVER_PERPETUAL_LICENSE = "server:set_perpetual_license",

    SERVERS_INFO = "config:settings:hall:info",
    GET_COMPARE_CONFIGURATIONS = "config:settings:query",
    CONFIG_UPLOAD = "config:settings:upload",
    UPLOAD_CONFIGURATION_REMOTELY = "config:settings:upload_remotely",

    GET_TIMEZONES = "subsidiary:countrytimezone:query",

    GET_SERVER_LICENSE = "slick:license:get",
    GET_SERVER_LICENSE_STATE = "slick:serverlicensestate:query",
    UPLOAD_LICENSE_SEED = "slick:license:server:init:post",
    CANCEL_LICENSE_PROCESS = "slick:license:server:cancel:post",
    REJECT_LICENSE_ID = "slick:serverlicensestate:id:reject:post",
    CONFIRM_LICENSE_ID = "slick:serverlicensestate:id:confirm:post",
    UPDATE_LICENSE_DURATION = "slick:license:put",
    UPDATE_REMOTELY_LICENSE = "slick:license:remote_apply",
    INVALIDATE_LICENSE = "slick:license:invalidate",
    GET_LICENSE_DOWNLOAD = "slick:license:server:download:get",
    SET_LICENSE_APPLIED = "slick:license:server:apply:post",
    RENEW_LICENSE = "slick:license:server:renew:post",
    GET_SERVER_LICENSES = "slick:license:query",
    GET_LICENSE_ACTIVITY = "slick:license:server:activities:get",

    UPLOAD_SPECIFICATION = "server:spec:create",
    GET_SERVER_SPECS = "server:spec:query",

    GET_DYNAMIC_HALL = "hall:hall_dynamics_query",
    GET_DYNAMIC_HALL_INFO = "hall:hall_info_dynamics_query",

    GET_PRODUCTION_INFO = "system:production:sys:get"
}
